import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { store } from "../../context/store";
import amex from "../../assets/Images/payements-icons/amex.svg";
import bhim from "../../assets/Images/payements-icons/bhim.svg";
import gpay from "../../assets/Images/payements-icons/gpay.svg";
import mastercard from "../../assets/Images/payements-icons/mastercard.svg";
import paytm from "../../assets/Images/payements-icons/paytm.svg";
import phonepe from "../../assets/Images/payements-icons/phonepe.svg";
import rupay from "../../assets/Images/payements-icons/rupay.svg";
import upi from "../../assets/Images/payements-icons/upi.svg";
import visa from "../../assets/Images/payements-icons/visa.svg";
import rubylogo from "../../assets/Images/ruby-logo.png";
import SocialIcons from "../Wrapper Components/SocialIcons";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaPinterestP,
  FaYoutube,
} from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { FaXTwitter } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";

// import christmasten from "../../assets/Images/christmas/christmas-ten.png";
import "./Footer.css";
// import FooterBg from "../../assets/Images/WEBSITE_FOOTER_NEW.jpg";
import GetApiCall from "../../helpers/GetApi";
export default function Footer() {
  const { clientData } = useContext(store);
  const [staticPages, setStaticPages] = useState([]);
  useEffect(() => {
    GetApiCall.getRequest("GetStaticPagesList").then((results) =>
      results.json().then((obj1) => {
        if (results.status == 200 || results.status == 201) {
          setStaticPages(obj1.data);
        }
      })
    );
  }, []);
  return (
    <>
      <footer className="py-3 px-lg-3 position-relative footer">
        <div className="container-fluid">
          <div className="row">
            {/* <div className="col-12">
              <ul className="d-flex footer-conatct-links justify-content-center flex-wrap align-items-end">
                {staticPages.map((link) => (
                  <li key={link.fld_id}>
                    <Link to={link.fld_route}>{link.fld_page_name}</Link>
                  </li>
                ))}
                <li>
                  <Link to="/aboutus">About Us</Link>
                </li>
                <li>
                  <Link to="/distributor">Distributors</Link>
                </li>
                <li>
                  <Link to="/faq">FAQ's</Link>
                </li>
                <li>
                  <Link to="/careers">Careers</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
              </ul>
              <div className="mt-3">
                <ul className="payments-icons ps-0">
                  <li>
                    <img alt="" src={mastercard} />
                  </li>
                  <li>
                    <img alt="" src={visa} />
                  </li>
                  <li>
                    <img alt="" src={amex} />
                  </li>
                  <li>
                    <img alt="" src={bhim} />
                  </li>
                  <li>
                    <img alt="" src={gpay} />
                  </li>

                  <li>
                    <img alt="" src={paytm} />
                  </li>
                  <li>
                    <img alt="" src={phonepe} />
                  </li>
                  <li>
                    <img alt="" src={rupay} />
                  </li>
                  <li>
                    <img alt="" src={upi} />
                  </li>

                </ul>
              </div>
            </div> */}
            <div className="col-lg-3 col-md-4">
              <div className="logo">
                <img src={rubylogo} alt="Ruby Food Logo " />

              </div>
              <p>Ruby Food is a trusted beverage brand offering a wide range of tasty and refreshing drinks made with quality ingredients.

              </p>
              <ul className="contact-links d-flex mt-2">
                <SocialIcons
                  link={clientData[0]?.facebook}
                  target="_blank"
                  logo={<FaFacebookF />}
                />
                <SocialIcons
                  link={clientData[0]?.instagram}
                  target="_blank"
                  logo={<AiFillInstagram />}
                />
                <SocialIcons
                  link={clientData[0]?.twitter}
                  target="_blank"
                  logo={<FaXTwitter />}
                />
                <SocialIcons
                  link={clientData[0]?.linkedin}
                  target="_blank"
                  logo={<FaLinkedinIn />}
                />
                <SocialIcons
                  link={clientData[0]?.pintrest}
                  target="_blank"
                  logo={<FaPinterestP />}
                />
                <SocialIcons
                  link={clientData[0]?.youtube}
                  target="_blank"
                  logo={<FaYoutube />}
                />
              </ul>
            </div>
            <div className="col-lg-3 ps-lg-5 our-links col-md-4 my-lg-0 my-2">
              <h3 className="ps-lg-5">Our Links</h3>
              <ul className="ps-lg-5">
                <li>
                  <FaAngleRight />
                  <a href="/aboutus">About  </a>               </li>
                <li>
                  <FaAngleRight />
                  <a href="/ct/beverages/1/1">Beverage </a>               </li>
                <li>                  <FaAngleRight />
                  <a href="/ct/combos/1/3">Combos</a></li>
                <li>                  <FaAngleRight />
                  <a href="/faq">FAQ</a>
                </li>
                <li><FaAngleRight /><a href="/distributor">Distributors</a></li>
              </ul>

            </div>
            <div className="col-lg-3 useful-links mt-lg-0 mt-2 col-md-4">
              <h3>Useful Links</h3>
              <ul>
                <li><FaAngleRight /><a href="/contact-us">Contact Us</a></li>
                <li><FaAngleRight /><a href="/terms-and-conditions">Terms and Conditions</a></li>
                <li><FaAngleRight /><a href="/privacy-policy">Privacy Policy</a></li>
                <li><FaAngleRight /><a href="/return-policy">Return Policy</a></li>
                <li><FaAngleRight /><a href="/careers">Careers</a></li>
              </ul>
            </div>
            <div className="col-lg-3 mt-lg-0 mt-2 mt-md-3">
              <h3>Get in Touch</h3>
              <div className="links">
                <h5>Address</h5>
                <p className="mb-0 fw-5">{clientData[0]?.name}</p>
                <p className="mb-2">{clientData[0]?.address}</p>
              </div>
              <div className="links mb-2">
                <h5 className="mb-0">Call Us</h5>
                <a href={`tel:${clientData[0]?.mobile}`}>
                  {clientData[0]?.mobile}
                </a>
              </div>
              <div className="links">
                <h5 className="mb-0">Email us</h5>
                <a href={`mailto:${clientData[0]?.email}`}>
                  {clientData[0]?.email}
                </a>
              </div>

            </div>
            <div className="mt-3">
              <ul className="payments-icons ps-0">
                <li>
                  <img alt="mastercard" src={mastercard} />
                </li>
                <li>
                  <img alt="visa" src={visa} />
                </li>
                <li>
                  <img alt="amex" src={amex} />
                </li>
                <li>
                  <img alt="bhim" src={bhim} />
                </li>
                <li>
                  <img alt="gpay" src={gpay} />
                </li>

                <li>
                  <img alt="paytm" src={paytm} />
                </li>
                <li>
                  <img alt="phonepe" src={phonepe} />
                </li>
                <li>
                  <img alt="rupay" src={rupay} />
                </li>
                <li>
                  <img alt="upi" src={upi} />
                </li>

              </ul>
            </div>

          </div>
        </div>
      </footer>
      <div className="container-fluid px-lg-4 footer-bottom py-2">
        <div className="row flex-column-reverse flex-lg-row">
          <div className="col-12 col-lg-6 text-lg-start text-center">
            Powered by{" "}
            <a href="https://bechofy.in/" target="blank">
              {" "}
              Bechofy
            </a>{" "}
            - <br className="d-block d-md-none" /> A Product of
            <a href="https://globaltrendz.com/" target="blank">
              &nbsp; Global Trendz
            </a>
          </div>
          <div className="col-12 col-lg-6 text-lg-end text-center">
            <p className="mb-0">
              Copyright &copy; {moment().format("YYYY")} {clientData[0]?.name}.
              All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
